import { z } from "zod";
import { ErrorCodeSchema } from "../../enums/api";

export type { ErrorCode } from "../../enums/api";

// The single envelope every error response uses across the API.
export const ApiErrorSchema = z.object({
  error: z.object({
    code: ErrorCodeSchema,
    message: z.string(),
    details: z.unknown().optional(),
  }),
});

export type ApiError = z.infer<typeof ApiErrorSchema>;
